<script lang="ts" setup>
import BaseIcon from '@/components/ui/BaseIcon/BaseIcon.vue'
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'reka-ui'

const model = defineModel<boolean | undefined>({ default: undefined })

const props = defineProps<{
  description?: string
  hideDescription?: boolean
  restrictedWidth?: boolean
}>()
</script>
<template>
  <DialogRoot v-model:open="model">
    <DialogTrigger as-child>
      <slot name="trigger"></slot>
    </DialogTrigger>
    <DialogPortal>
      <DialogOverlay
        class="fixed inset-0 z-50 bg-[rgba(34,34,34,0.4)] backdrop-blur data-[state=closed]:animate-hideOut data-[state=open]:animate-opacityIn"
      />
      <DialogContent
        class="card fixed left-[50%] top-[50%] z-50 flex max-h-screen origin-top-left translate-x-[-50%] translate-y-[-50%] flex-col px-9 pr-5 focus:outline-none data-[state=open]:animate-scaleIn"
        :class="{ 'w-[480px]': props.restrictedWidth }"
      >
        <div class="flex justify-between gap-10">
          <div class="flex-1">
            <div v-if="$slots.pretitle" class="mb-7.5 px-1">
              <slot name="pretitle"></slot>
            </div>
            <DialogTitle class="mb-7.5 px-1 text-h2 font-semibold">
              <slot name="title"></slot>
            </DialogTitle>
            <DialogDescription
              class="mb-7.5 px-1 text-base"
              :class="{ 'sr-only': props.hideDescription }"
            >
              <slot name="description">{{ props.description }}</slot>
            </DialogDescription>
          </div>
          <div v-if="$slots.topActions" class="pr-7.5">
            <slot name="topActions"></slot>
          </div>
        </div>

        <div class="overflow-y-auto px-1 py-[1px] pr-5">
          <slot name="content"></slot>
        </div>

        <div v-if="$slots.actions" class="mt-7.5 flex gap-5 px-1">
          <slot name="actions"></slot>
        </div>
        <DialogClose class="absolute right-5 top-5" aria-label="Close">
          <BaseIcon icon="CloseIcon" />
        </DialogClose>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
